import React, { useEffect, useState } from "react";
import "../Style/Component/Driverdata.css";
import Personaldata from "./Personaldata";
import Detailtables from "./Detailtables";
import { useParams } from "react-router-dom";
import { getWithTokenAPI } from "../Util/Api";
import { useSelector } from "react-redux";
const Driverdata = () => {
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const { type, id } = useParams();

  console.log(type, "typetypetype")
  const [specificdata, setSpecificdata] = useState({});
  const fetchspecificdata = async () => {
    try {
      const res = await getWithTokenAPI(token, `/user/profile/${id}`);
      setSpecificdata(res?.data);
    } catch {
      console.log("Error in fetching Limit Api");
    }
  };

  const fetchdriverstats = async () => {
    try {
      const res = await getWithTokenAPI(token, `/driver/${id}/stats`);
      setStats(res?.data);
    } catch {
      console.log("Error in fetching Limit Api");
    }
  };

  useEffect(() => {
    fetchspecificdata();
  }, [token]);
  const [stats, setStats] = useState({});
  useEffect(() => {
    fetchdriverstats();
  }, [token]);

  const refreshDriverData = () => {
    fetchspecificdata();
    fetchdriverstats();
  };
  return (
    <div className="driverdata">
      <Personaldata data={specificdata} stats={stats} refreshDriverData={refreshDriverData}/>
      <Detailtables data={specificdata} stats={stats} />
    </div>
  );
};

export default Driverdata;
